import {syncPlayerProfile} from "../services/player";
import {getTelegramUser} from "../services/telegramWebApp";

// syncPlayerProfileIfNeeded сравнивает данные Telegram и бэка и запускает синхронизацию при расхождении.
export const syncPlayerProfileIfNeeded = (player) => {
    if (!player) {
        return Promise.resolve();
    }

    const tgUser = getTelegramUser();
    if (!tgUser) {
        return Promise.resolve();
    }

    return Promise.resolve().then(() => {
        const tgName = [tgUser.first_name, tgUser.last_name].filter(Boolean).join(' ').trim();
        const tgAvatar = tgUser.photo_url || '';
        const currentName = (player.name || '').trim();
        const currentAvatar = player.avatar || '';
        const shouldSync = (tgName && tgName !== currentName) || (tgAvatar && tgAvatar !== currentAvatar);
        if (!shouldSync) return Promise.resolve();
        return syncPlayerProfile();
    }).catch(err => {
        console.log("Failed to sync player profile:", err);
    });
};
